import React from "react";

import '../Style.css';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import BTB_10 from '../Assets/Images/Economic Scales/Table Top Scale/BTB-10.png'
import BTB_10_pole from '../Assets/Images/Economic Scales/Table Top Scale/BTB-10_Pole.png'
import BTB_14 from '../Assets/Images/Economic Scales/Table Top Scale/BTB-14.png'
import BTB_15 from '../Assets/Images/Economic Scales/Table Top Scale/BTB-15_Pole.png'
import MTB_14 from '../Assets/Images/Economic Scales/Table Top Scale/MTB-14.png'




function Tabletopscale() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">Tabletop Scale</p>

                    </div>
                    <div className="row   row-cols-lg-2 row-cols-1 min-vh-100 justify-content-center g-4 align-items-center ">
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-10
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_10} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 20 / 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 2 / 5 g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) : 250 x 300</p>
                                        </div>

                                        <a href="/BTB_10" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-10 Pole
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_10_pole} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 20 / 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 2 / 5 g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) : 250 x 300</p>
                                        </div>

                                        <a href="/BTB_10_pole" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-14
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_14} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 20 / 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 2 / 5 g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) : 250 x 300</p>
                                        </div>

                                        <a href="/BTB_14" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    BTB-15
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={BTB_15} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 20 / 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 2 / 5 g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) : 250 x 325</p>
                                        </div>

                                        <a href="/BTB_15" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    MTB-14
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={MTB_14} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 20 / 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 2 / 5 g</p>
                                            <p className="about-card-para-css">Platter Size ( mm ) : 250 x 300</p>
                                        </div>

                                        <a href="/MTB_14" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>


        </div >

    );
}

export default Tabletopscale;
